import type { Time } from "../types/Units"

/**
 * Converts a Unix timestamp to Date object
 * @param time - Optional Time (Unix timestamp in seconds). If undefined, uses current time
 * @returns Date object
 *
 * @example
 * ```ts
 * import { FromUnixTime } from "@pdfking/tfunc"
 *
 * FromUnixTime(1735689600 as Time) // Date: 2025-01-01T00:00:00.000Z
 * FromUnixTime() // Date: current time
 * ```
 */
export const FromUnixTime = (time?: Time): Date =>
  new Date(time ? time * 1000 : Date.now())
